export default {
  description:
    'Verwende code: {{code}}, um einen Rabatt auf deine {{count}} nächsten zu erhalten, wenn du hier bestellst.',
  discounts: {
    percentage: '{{discount}}%',
    fixed: '{{discount}}',
  },
  list: {
    item: {
      order: '{{orderNumber}}. Bestellung',
    },
  },
  savings: {
    percentage: 'Du sparst insgesamt {{totalSaved}}%',
    fixed: 'Du sparst insgesamt {{totalSaved}}',
  },
  apply: 'Anwenden',
  applied: 'Angewendet',
  remove: 'Entfernen',
  custom_button: {
    done: 'Fertig',
  },
};
